// product grid/list
function listgridJavascript() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
      link.addEventListener('click', function(event) {
          Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
          this.classList.add('active');
          if(this.classList.contains('listv')){
              document.getElementById('product-grid').classList.add('product-list');
              document.getElementById('product-grid').classList.remove('product-grid');
              document.getElementById('product-grid').classList.remove('product-gallery');
          }else if(this.classList.contains('gridv')){
              document.getElementById('product-grid').classList.add('product-grid');
              document.getElementById('product-grid').classList.remove('product-list');
              document.getElementById('product-grid').classList.remove('product-gallery');
          }else if(this.classList.contains('galleryv')){
              document.getElementById('product-grid').classList.add('product-gallery');
              document.getElementById('product-grid').classList.remove('product-list');
              document.getElementById('product-grid').classList.remove('product-grid');
          }
      });
  });
}
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// on scroll play video using high-performance IntersectionObserver
if ('IntersectionObserver' in window) {
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.play().catch(() => {});
      } else {
        entry.target.pause();
      }
    });
  }, { threshold: 0.5 });

  function initVideoObserver() {
    document.querySelectorAll('video[autoplay]').forEach((video) => videoObserver.observe(video));
  }
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initVideoObserver);
  } else {
    initVideoObserver();
  }
  document.addEventListener('shopify:section:load', initVideoObserver);
} else {
  // Passive throttled fallback for legacy browsers
  let isScrolling = false;
  window.addEventListener('scroll', () => {
    if (!isScrolling) {
      window.requestAnimationFrame(() => {
        videoScroll();
        isScrolling = false;
      });
      isScrolling = true;
    }
  }, { passive: true });
  function videoScroll() {
    const videos = document.querySelectorAll('video[autoplay]');
    if (videos.length === 0) return;
    const windowHeight = window.innerHeight;
    videos.forEach((thisVideoEl) => {
      const videoHeight = thisVideoEl.clientHeight;
      const videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if (videoClientRect <= (windowHeight - videoHeight * 0.5) && videoClientRect >= (0 - videoHeight * 0.5)) {
        thisVideoEl.play().catch(() => {});
      } else {
        thisVideoEl.pause();
      }
    });
  }
}

// timer - only activate when countdown elements exist
let countDownTimer = null;
function initCountdown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  if (countCardSections.length === 0) {
    if (countDownTimer) {
      clearInterval(countDownTimer);
      countDownTimer = null;
    }
    return;
  }
  countDown();
  if (!countDownTimer) {
    countDownTimer = setInterval(countDown, 1000);
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCountdown);
} else {
  initCountdown();
}
document.addEventListener('shopify:section:load', initCountdown);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  if (countCardSections.length === 0) {
    if (countDownTimer) {
      clearInterval(countDownTimer);
      countDownTimer = null;
    }
    return;
  }
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}
